module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-none element-without-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("I was born at the crossing of the white church*"), _c('sup', [_c('a', {
    staticClass: "endnote-source",
    attrs: {
      "href": "#/epigraph2#uncategorized-endnote-1-text",
      "id": "uncategorized-endnote-1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("In the shadow of the black mountain.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Where the walls bleed broken bottles")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And the barbed-wire binds the fountain.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("I grew up with the promise of the chosen,")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Shouldered the banners of the certain,")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Was cut down by the falseness of prophets,")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Abandoned by the truth everlasting.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Laughed in the faces of the fallen,")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Was banished to the valley of not knowing.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Mad dogs, King Rats, Butchers,")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sheebeens of wickedness and of self-loathing.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("I was born at the crossing of the white church")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("In the shadow of the black mountain")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Where the wild things burn their young")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And the sparks rise up to heaven.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnotes"
  }, [_c('div', {
    staticClass: "endnotes-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "endnote-text",
    attrs: {
      "id": "uncategorized-endnote-1-text"
    }
  }, [_c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "endnote-text-number"
  }, [_c('a', {
    staticClass: "endnote-backlink",
    attrs: {
      "href": "#/epigraph2#uncategorized-endnote-1"
    }
  }, [_vm._v("1")])]), _c('i', [_vm._v("* Shankill (‘Old Church’) was otherwise formally ‘the church of the white crossing’ (Ecclesia alba de vado).")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d44ffea8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph-2.vue
// module id = 75
// module chunks = 0